import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <>
            <footer class="footer-dark bg-dark-gray pb-0 pt-0 cover-background" style={{ backgroundImage: `url(${require('../assets/images/footer-bg.jpg')})` }}>

                <div class="container pt-4 pb-4 md-pt-45px md-pb-45px">

                    <div class="row justify-content-center">
                        <div class="col-6 col-lg-3 last-paragraph-no-margin order-sm-1 md-mb-50px xs-mb-30px">

                            <a href="index.php" class="footer-logo mb-15px d-inline-block"><img src="images/apollo-logo-color-r.png" data-at2x="images/apollo-logo-color-r.png" alt="" /></a>

                            <p class="w-80 sm-w-100"> As Young Business, We've dedicated ourselves to weaving tradition and sustainability into the very fabric of your home.</p>

                            <div class="elements-social social-icon-style-02 mt-15px">

                                <ul class="small-icon light">

                                    <li><a class="facebook" href="https://www.facebook.com/" target="_blank"><i class="fa-brands fa-facebook-f"></i></a></li>





                                    <li><a class="instagram" href="http://www.instagram.com" target="_blank"><i class="fa-brands fa-instagram"></i></a></li>

                                </ul>

                            </div>

                        </div>


                        <div class="col-6 col-lg-2 col-sm-4 xs-mb-30px order-sm-3 order-lg-2">

                            <span class="fs-16 alt-font fw-500 d-block text-white mb-5px">Collections</span>

                            <ul>

                                <li><a href="#">Bath</a></li>

                                <li><a href="#">Bedding</a></li>

                                <li><a href="#">Beach Wear</a></li>

                                <li><Link to="/collaboration">Collaboration</Link></li>



                                {/* <li><a href="#">Thows</a></li>

                                <li><a href="#">Comforters</a></li> */}



                            </ul>

                        </div>


                        <div class="col-6 col-lg-2 col-sm-4 xs-mb-30px order-sm-3 order-lg-2">

                            <span class="fs-16 alt-font fw-500 d-block text-white mb-5px">Information</span>

                            <ul>


                                <li><Link to="/">Home</Link></li>

                                <li><Link to="/our-story">About</Link></li>

                                <li><a href="#">Team</a></li>

                                <li><a href="#">Career</a></li>

                                <li><Link to="/contact">Contact </Link></li>



                            </ul>

                        </div>


                        <div class="col-6 col-lg-2 col-sm-4 xs-mb-30px order-sm-3 order-lg-2">

                            <span class="fs-16 alt-font fw-500 d-block text-white mb-5px">Others</span>

                            <ul>

                                <li><a href="#">Terms of use</a></li>

                                <li><a href="#">SiteMap</a></li>

                                <li><a href="#">Legal</a></li>

                                <li><a href="#">Catalog</a></li>

                                <li><a href="#">Social Media Icon</a></li>



                            </ul>

                        </div>



                        <div class="col-lg-3 col-sm-6 ps-20px sm-ps-15px md-mb-50px xs-mb-0 order-sm-2 order-lg-5">

                            <span class="fs-16 alt-font fw-500 d-block text-white mb-5px">Newsletter</span>

                            <div class="mb-20px">Get everything you need succeed!</div>

                            <div class="d-inline-block w-100 newsletter-style-02 position-relative mb-15px">

                                <form action="email-templates/subscribe-newsletter.php" method="post" class="position-relative w-100">

                                    <input class="bg-blue-tangaroa border-color-transparent-white-light w-100 form-control pe-50px ps-20px lg-ps-15px required" type="email" name="email" placeholder="Enter your email" />

                                    <input type="hidden" name="redirect" value="" />

                                    <button class="btn pe-20px submit" aria-label="submit"><i class="icon feather icon-feather-mail icon-small text-white"></i></button>

                                    <div class="form-results border-radius-4px pt-5px pb-5px ps-15px pe-15px fs-14 lh-22 mt-10px w-100 text-center position-absolute d-none"></div>

                                </form>

                            </div>

                            <div class="footer-card">

                                <a href="#" class="d-inline-block me-5px align-middle"><img src="images/payment-icon-01.png" alt="" /></a>

                                <a href="#" class="d-inline-block me-5px align-middle"><img src="images/payment-icon-02.png" alt="" /></a>

                                <a href="#" class="d-inline-block me-5px align-middle"><img src="images/payment-icon-03.png" alt="" /></a>

                                <a href="#" class="d-inline-block me-5px align-middle"><img src="images/payment-icon-04.png" alt="" /></a>

                            </div>

                        </div>



                    </div>

                </div>

                <div class="border-top border-color-transparent-white-light pt-30px pb-30px">

                    <div class="container">

                        <div class="row align-items-center justify-content-center">

                            <div class="col-xl-6 last-paragraph-no-margin text-center text-xl-start lg-mt-20px order-3 order-xl-1">

                                <p class="fs-14 mb-0 w-90 xl-w-100">This site is protected by reCAPTCHA and the Google <a href="/privacy" class="text-white text-decoration-line-bottom">privacy policy</a> and terms of service apply.</p>

                                <p class="fs-14 w-90 xl-w-100">&copy; 2024 Apollo Overseas.  Powered by <a href="https://www.rajmith.com/" target="_blank" class="text-white text-decoration-line-bottom">RAJMITH</a></p>

                            </div>

                            <div class="col-6 col-xl-3 col-md-3 col-sm-5 text-center text-xl-start order-1 order-xl-2">

                                <span class="lh-26 alt-font d-block">Need support?</span>

                                <a href="tel: 9999908079" class="fs-16 text-white fw-500">INDIA +91- (9999908079)</a>

                            </div>

                            <div class="col-6 col-xl-3 col-md-3 col-sm-5 text-center text-xl-start order-2 order-xl-3">

                                <span class="lh-26 alt-font d-block">Customer care</span>

                                <a href="mailto:info@apollo-overseas.us" class="fs-16 text-white fw-500">info@apollo-overseas.us</a>

                            </div>

                        </div>

                    </div>

                </div>

            </footer>


            <div id="cookies-model" class="cookie-message bg-dark-gray border-radius-8px">

                <div class="cookie-description fs-14 text-white mb-20px lh-22">We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By clicking "Allow cookies" you consent to our use of cookies. </div>

                <div class="cookie-btn">

                    <a href="#" class="btn btn-transparent-white border-1 border-color-transparent-white-light btn-very-small btn-switch-text btn-rounded w-100 mb-15px" aria-label="btn">

                        <span>

                            <span class="btn-double-text" data-text="Cookie policy">Cookie policy</span>

                        </span>

                    </a>

                    <a href="#" class="btn btn-white btn-very-small btn-switch-text btn-box-shadow accept_cookies_btn btn-rounded w-100" data-accept-btn aria-label="text">

                        <span>

                            <span class="btn-double-text" data-text="Allow cookies">Allow cookies</span>

                        </span>

                    </a>

                </div>

            </div>



            <div class="sticky-wrap d-none d-xl-inline-block z-index-1" data-animation-delay="100" data-shadow-animation="true">

                <div class="elements-social social-icon-style-10">

                    <ul class="fs-15 fw-500">

                        <li class="me-30px"><a class="facebook" href="https://www.facebook.com/" target="_blank">

                            <i class="fa-brands fa-facebook-f me-10px"></i>

                            <span class="alt-font">Facebook</span>

                        </a>

                        </li>



                        <li class="me-30px">

                            <a class="twitter" href="http://www.twitter.com" target="_blank">

                                <i class="fa-brands fa-twitter me-10px"></i>

                                <span class="alt-font">Twitter</span>

                            </a>

                        </li>

                        <li>

                            <a class="instagram" href="http://www.instagram.com" target="_blank">

                                <i class="fa-brands fa-instagram me-10px"></i>

                                <span class="alt-font">Instagram</span>

                            </a>

                        </li>

                    </ul>

                </div>

            </div>


            <div class="scroll-progress d-none d-xxl-block">

                <a href="#" class="scroll-top" aria-label="scroll">

                    <span class="scroll-text">Scroll</span><span class="scroll-line"><span class="scroll-point"></span></span>

                </a>

            </div>

        </>
    )
}
